import { useMemo } from 'react';
import {
  EvidenceViewer,
  packUrlFromSearch
} from '@lt-web-platform/evidence-viewer';

/**
 * Public standalone shell. The embed contract (cerebro/evidence/evidence.md):
 * a single ?pack=<URL-encoded url> query param, read ONCE at mount — hosts
 * refresh the iframe src to swap packs. Without the param, the shared
 * component's landing screen owns the UX (drop zone, picker, URL form).
 */
export default function App() {
  const initialPack = useMemo(
    () => packUrlFromSearch(window.location.search),
    []
  );
  return <EvidenceViewer initialPack={initialPack} />;
}
